import React from 'react'
import MedicineNav from '../Mednavbar/MedicineNav.js'
import Product from './Product.js'

function Productmain() {
  return (
    <div>
      <MedicineNav/>
      <Product/>
    </div>
  )
}

export default Productmain
